export class SpinButtonViewEvents {
    public static readonly SPIN_BUTTON_CLICKED: symbol = Symbol('SPIN_BUTTON_CLICKED');
    public static readonly SPIN_BUTTON_HOLD: symbol = Symbol('SPIN_BUTTON_HOLD');
    public static readonly BACKGROUND_CLICKED: symbol = Symbol('BACKGROUND_CLICKED');
}